import React, { useState, useEffect, useMemo } from 'react';
import { Dropdown } from 'primereact/dropdown';
import { useGetVehicleItemsQuery } from '../../api';

const CarItemCodeDropdown = ({
    value,
    onChange,
    className,
    disabled,
    productGroup,
    model,
    placeholder = "Araç Kalem Kodu seçiniz veya arayınız"
}) => {
    const [selectedItem, setSelectedItem] = useState(null);

    const queryParams = productGroup ? { productGroup } : model ? { model } : null;
    const { data: vehicleItemsResponse = [], isLoading } = useGetVehicleItemsQuery(queryParams, {
        skip: !queryParams
    });

    const options = useMemo(() => {
        const allOption = { displayText: 'ALL', recordValue: 'ALL' };
        return [allOption, ...vehicleItemsResponse];
    }, [vehicleItemsResponse]);

    useEffect(() => {
        if (value) {
            setSelectedItem(value);
        }
    }, [value]);

    const handleSelectionChange = (e) => {
        setSelectedItem(e.value);
        onChange(e.value || '');
    };

    return (
        <Dropdown
            value={selectedItem}
            options={options}
            onChange={handleSelectionChange}
            optionLabel="displayText"
            optionValue="recordValue"
            filter
            showClear
            className={className}
            placeholder={placeholder}
            loading={isLoading}
            disabled={disabled}
            itemTemplate={(option) => (
                <div>
                    <span>{option.displayText}</span>
                </div>
            )}
        />
    );
};

export default CarItemCodeDropdown;